//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from "clipboard";
import CTab from "@/components/CTab";
import ScrollMore from "@/components/ScrollMore";
import NoData from "@/components/NoData";
import OrderService from "@/api/orderService";
import WxService from "@/api/wxService";
import WxJsSdk from "@/utils/wxJsSdk";
import SysUtils from "@/utils/sysUtils";

export default {
  data() {
    return {
      tabs: [
        {
          value: "待支付",
        },
        {
          value: "已支付",
        },
      ],
      flowStep: 0,
      pageData: {
        page: 1,
        size: 20,
        nextPage: false,
      },
      list: [],
      scrollReset: false,
      disabled: false, // 是否禁用提交操作
    };
  },
  computed: {
    copyIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/copy.png");
      } else {
        return require("../../assets/theme_black/copy.png");
      }
    },
  },
  mounted() {
    if (SysUtils.isWeiXin()) {
      let url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      WxService.getConfig(encodeURIComponent(url))
        .then((res) => {
          if (res) {
            this.$wechat.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，公众号的唯一标识
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature, // 必填，签名
              jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
            });
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    }

    this.query(this.flowStep);
  },
  methods: {
    handleTabClick(e) {
      console.info(e);
      this.flowStep = e;
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
      this.scrollReset = true;
    },
    /**
     * 查询提货记录
     */
    query(flowStep) {
      OrderService.queryOrderList(
        this.pageData.page,
        this.pageData.size,
        flowStep
      )
        .then((result) => {
          let res = result.data;
          this.pageData.page = res.currPage;
          this.pageData.pageSize = res.pageSize;
          if (res.totalPage <= res.currPage) {
            this.pageData.nextPage = false;
          } else {
            this.pageData.nextPage = true;
          }
          res.list.forEach((item) => {
            this.list.push({
              ...item,
            });
          });
          if (this.$root.themeType == "black") {
            // 如果当前主题是黑金
            // 如果列表没有数据，显示黑色背景，否则显示白色背景
            if (this.list.length > 0) {
              document.documentElement.style.backgroundColor = "#fff";
            }
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 上拉加载更多
     */
    onScrollBottom() {
      if (this.pageData.nextPage) {
        this.pageData.page += 1;
        this.query(this.flowStep);
      }
    },
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
    },
    /**
     * 点击去支付
     */
    toPay(e) {
      if (!this.disabled) {
        this.disabled = true;
        OrderService.orderWxPay(e.id)
          .then((res) => {
            this.disabled = false;
            const wxPayData = {
              appId: res.data.appId,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              paySign: res.data.paySign,
              signType: res.data.signType,
              timestamp: res.data.timeStamp,
            };
            WxJsSdk.chooseWXPay(wxPayData)
              .then((result) => {
                // 如果当前取消了支付
                if (result.errMsg == "chooseWXPay:cancel") {
                  // res.payFlowId
                } else {
                  // 重新获取加载待支付的数据
                  this.handleTabClick(0);
                  this.$vux.toast.text("操作成功");
                }
              })
              .catch((err) => {
                console.log("支付失败:-------------");
                console.log(err);
              });
          })
          .catch((err) => {
            this.disabled = false;
            this.$vux.toast.text(err.msg);
          });
      }
    },
    /**
     * 复制操作
     */
    handleCopy(dom) {
      var clipboard = new Clipboard(dom);
      clipboard.on("success", (e) => {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        this.$vux.toast.show({
          text: "复制成功",
        });
        e.clearSelection();
        clipboard.destroy(); // 清理事件及创建的对象
      });

      clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        clipboard.destroy();
      });
    },
  },
  components: {
    CTab,
    ScrollMore,
    NoData,
  },
  destroyed() {
    if (this.$root.themeType == "black") {
      // 如果当前主题是黑金，当前页面销毁时将主题背景色重新改为黑色
      document.documentElement.style.backgroundColor = "#242626";
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/robbing/orderList.vue